import { useRef, useState } from "react";

export function useFilterPanel({ initialSort = [], initialFilters = [] } = {}) {
  const [term, setTerm] = useState("");

  const sortSelected = useRef(initialSort);
  const filtersSelected = useRef(initialFilters);

  return {
    term,
    setTerm,
    sortSelected,
    filtersSelected
  };
}